import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const DrawerUploadUrlSchema = Yup.object().shape({
    path: Yup.string().required('URL é obrigatório'),
    ordering: Yup.string().required('Ordenação é obrigatória'),
});